import { Router } from 'express';
import * as controller from './channels.controller';
import { authMiddleware } from '../../middleware/auth.middleware';

const router = Router({ mergeParams: true });
router.use(authMiddleware);

// /teams/:teamId/channels
router.get('/', controller.list);
router.post('/', controller.create);

// /channels/:id
router.get('/:id', controller.getOne);
router.patch('/:id/archive', controller.archive);
router.post('/:id/join', controller.join);
router.post('/:id/leave', controller.leave);
router.post('/:id/read', controller.markRead);

export default router;
